<template>
    <div class="d-flex align-items-center">
        <span class="me-1 ms-auto">
            <span class="badge badge-pill badge-gray"> New </span>
        </span>
        <button class="btn btn-primary btn-xs ms-2" @click="addProblem()">Add Problem</button>
    </div>
    <div class="mt-2">
        <table class="table table-responsive-md border border-gray overflow-auto">
            <thead>
                <tr class="bg-table-header">
                    <th>Problem</th>
                    <th>Onset Date</th>
                    <th>
                        Last Addressed
                        <span
                            v-tooltip="{
                                title: 'This is the last date that this problem was addressed in a visit note.'
                            }"
                        >
                            <i class="fas fa-info-circle text-info"></i>
                        </span>
                    </th>
                    <th class="text-center">Present on Admission</th>
                    <th class="text-end">Actions</th>
                </tr>
            </thead>
            <!--Empty Table-->
            <TableEmpty
                v-if="problems.length == 0 && newProblems.length == 0"
                :col-span="columns"
                component="problems"
                secondary-message="No Problems Found"
            />
            <!--Existing Diagnoses-->
            <ProblemsTableRow
                v-for="(problem, index) of activeProblems"
                :index="index"
                :key="problem.id"
                :problem="problem"
                :move-problem-up="moveProblem"
                :move-problem-down="moveProblem"
                :resolve-problem="resolveProblem"
                :first="index === 0"
                :last="index === activeProblems.length - 1"
                :id="id"
                :deleteProblem="deleteProblem"
                :application="application"
            />
            <!--New Diagnoses-->
            <ProblemsTableRow
                v-for="(problem, index) of newProblems"
                :index="index"
                :key="problem.id"
                :problem="problem"
                :updateProblem="updateProblem"
                v-model:is-add-requested="isAddRequested"
                :save-new-problem="saveNewProblem"
                v-show="newProblems.length > 0"
                :cancel-save-new-problem="cancelSaveNewProblem"
                :is-new-terminal="isNewTerminal"
                :application="application"
            />
        </table>
    </div>
</template>

<script lang="ts" src="./ProblemsTable.ts"></script>
